var _defs, _circle, _path, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleChromeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    width: 256,
    height: 256,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "chromeTitle",
    lang: "en"
  }, "Google Chrome Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "chromeTitle",
    lang: "en"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueFade",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#81b4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c5a94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "redFade",
    gradientUnits: "userSpaceOnUse",
    x1: 128,
    y1: 16,
    x2: 128,
    y2: 107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f06b59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#df2227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "greenFade",
    gradientUnits: "userSpaceOnUse",
    x1: 72,
    y1: 225,
    x2: 118,
    y2: 149
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#388b41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4cb749"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellowFade",
    gradientUnits: "userSpaceOnUse",
    x1: 187,
    y1: 220,
    x2: 138,
    y2: 102
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e4b022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#fcd209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "redShadow",
    gradientUnits: "userSpaceOnUse",
    x1: 80,
    y1: 140,
    x2: 80,
    y2: 60
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "black",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "black",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "black",
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "greenShadow",
    gradientUnits: "userSpaceOnUse",
    x1: 164,
    y1: 161,
    x2: 109,
    y2: 217
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "black",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "black",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "black",
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellowShadow",
    gradientUnits: "userSpaceOnUse",
    x1: 139,
    y1: 179,
    x2: 147,
    y2: 100
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "black",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "black",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "black",
    stopOpacity: 0.03
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 110,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillOpacity: 0.1,
    d: "M 198 148 A 70 70 0 0 0 58 148 L 78 148 A 50 50 0 0 1 178 148"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "black",
    fillOpacity: 0.1,
    cx: 133,
    cy: 142,
    r: 38
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "50%",
    cy: "50%",
    r: 41,
    fill: "url(#blueFade)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#redFade)",
    d: "M 228 78 A 112 112 0 0 0 35 65 L 80 143 A 50 50 0 0 1 127 78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#greenFade)",
    d: "M 35 65 A 112 112 0 0 0 119 239 L 166 159 A 50 50 0 0 1 80 143"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yellowFade)",
    d: "M 119 239 A 112 112 0 0 0 228 78 L 127 78 A 50 50 0 0 1 166 159"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#redShadow)",
    d: "M 35 65 L 80 143 A 50 50 0 0 1 82 109 L 37 62"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#greenShadow)",
    d: "M 119 239 L 166 159 A 50 50 0 0 1 137 176 L 117 239"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yellowShadow)",
    d: "M 228 78 L 127 78 A 50 50 0 0 1 166 97 L 230 81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleChromeLogo);
export default __webpack_public_path__ + "static/media/google-chrome-logo.fecc56c1d24569cfead0c17c836b4b69.svg";
export { ForwardRef as ReactComponent };